module.exports = __webpack_public_path__ + "img/homemengbancolor.3f6b2fd1.png";